import { useTranslations } from '@vocab/react';

import { withAppEnhancers } from 'src/app/views/enhancers/withAppEnhancers';
import { useCopyJob } from 'src/app/views/hooks/useCopyJob';
import { useCreateJob } from 'src/app/views/hooks/useCreateJob';
import { useEditDraft } from 'src/app/views/hooks/useEditDraft';
import { useExperiments } from 'src/app/views/hooks/useExperiments';
import { useJobId } from 'src/app/views/hooks/useJobId';
import { useLastValidRoute } from 'src/app/views/hooks/useLastValidRoute';
import { useRefreshAdProductSet } from 'src/app/views/hooks/useRefreshProductSetForAdPosting';
import { useSelectedProduct } from 'src/app/views/hooks/useSelectedProduct';
import { useSelectedRRQuestions } from 'src/app/views/hooks/useSelectedRRQuestions';
import { useTealiumCreateFlowType } from 'src/app/views/hooks/useTealiumCreateFlowType';
import { SeoTitle } from 'src/app/views/shared/SeoTitle';
import type { ContainerProps } from 'src/types/app';

import { useUpdateDraftIdParam } from '../../hooks/useUpdateDraftIdParam';
import translations from '../.vocab';

const CreateFlowContainer = ({ children }: ContainerProps): JSX.Element => {
  useExperiments();
  useJobId();
  useRefreshAdProductSet();
  useCreateJob();
  useSelectedRRQuestions();
  useSelectedProduct();
  useUpdateDraftIdParam();

  return <>{children}</>;
};

export const CreateFlowWithInitialData = (props: ContainerProps) => {
  const { t } = useTranslations(translations);

  const { loading: isEditDraftLoading } = useEditDraft();
  const { loading: isCopyJobLoading } = useCopyJob();
  const { loading: isLastValidRouteLoading } = useLastValidRoute();

  useTealiumCreateFlowType();
  return (
    <>
      <SeoTitle title={t('create-container-seo-title')} />
      {isEditDraftLoading ||
      isCopyJobLoading ||
      isLastValidRouteLoading ? null : (
        <CreateFlowContainer {...props} />
      )}
    </>
  );
};

export default withAppEnhancers(CreateFlowWithInitialData);
